module.exports = __webpack_public_path__ + "img/badge_positive.ff000f89.svg";